module.exports = __webpack_public_path__ + "img/home-premium-1.042d6e42.png";